import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"
import { mode } from "components/Common/Utils"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link, useNavigate } from "react-router-dom"
import alyamama_logo from "assets/images/login/alyamama_logo.svg"
import SARLogo from "assets/images/login/sar-logo-2.svg"
import { useSelector } from "react-redux"

const Sidebar = props => {
  const [sidebarUpdated, setSidebarUpdated] = useState(false)

  const navigate = useNavigate()
  const { userRole, candidateRole } = useSelector(
    state => state.RolesAndPermissions
  )
  const { userType } = useSelector(state => state.Login)

  const getCandidatesNavItems = () => {
    const candidateNavItems = [
      {
        key: "profile",
        label: "Profile",
        path: "/profile",
        icon: "bx bx-user",
      },
      {
        key: "time-line",
        label: "Time Line",
        path: "/time-line",
        icon: "bx bx-line-chart",
      },
      {
        key: "my-interviews",
        label: "My Interviews",
        path: "/my-interviews",
        icon: "bx bxs-user-voice",
      },
    ]

    if (candidateRole?.can_show_theoretical_training_section) {
      candidateNavItems.push({
        key: "my-theoretical-training",
        label: "My Theoretical Training",
        path: "/candidate-theoretical-training",
        icon: "bx bxs-book-open",
      })
    }

    if (candidateRole?.can_show_practical_training_section) {
      candidateNavItems.push({
        key: "my-practical-training",
        label: "My Practical Training",
        path: "/candidate-practical-training",
        icon: "bx bxs-wrench",
      })
    }

    if (candidateRole?.can_show_trial_run_operation) {
      candidateNavItems.push({
        key: "trial-operations",
        label: "Trial Operations",
        path: "/candidate-trial-operations",
        icon: "bx bxs-hourglass",
      })
    }

    if (candidateRole?.can_show_contract_section) {
      candidateNavItems.push({
        key: "candidate-contracts",
        label: "My Contracts",
        path: "/candidate-contracts",
        icon: "bx bxs-id-card",
      })
    }

    return candidateNavItems
  }

  const getAdminNavItems = mode => {
    const adminNavItems = [
      {
        key: "dashboard",
        label: "Dashboards",
        path: "/dashboard",
        icon: "mdi mdi-view-dashboard",
      },
      {
        key: "profile",
        label: "Profile",
        path: "/profile",
        icon: "bx bx-user",
      },
      {
        key: "candidate",
        label: "Candidates",
        path: "/applications",
        icon: "bx bxs-user-detail",
      },
      {
        key: "interview_schedule",
        label: "Interviews",
        path: "/interview-appointments",
        icon: "bx bxs-calendar",
      },
      {
        key: "trial_run",
        label: "Trial Operation",
        path: "/trial-operation",
        icon: "bx bxs-hourglass",
      },
      {
        key: "catering",
        label: "Catering",
        path: "/catering",
        icon: "bx bx-restaurant",
      },
      {
        key: "theoretical_training",
        label: "Theoretical Training",
        path: "/theoretical-training",
        icon: "bx bxs-book",
      },
      {
        key: "practical_training",
        label: "Practical Training",
        path: "/practical-training",
        icon: "bx bxs-wrench",
      },
      {
        key: "training_materials",
        label: "Training Materials",
        path: "/training-materials",
        icon: "bx bxs-graduation",
      },
      {
        key: "roles",
        label: "Roles & Permissions",
        path: "/roles-and-permissions",
        icon: "bx bx-lock",
      },
      {
        key: "staff_users",
        label: "Users",
        path: "/users",
        icon: "bx bx-user",
      },
      {
        key: "export_operation",
        label: "Export Operations",
        path: "/export-operations",
        icon: "bx bxs-report",
      },
      {
        key: "id_card",
        label: "ID Cards",
        path: "/id-cards",
        icon: "bx bx-id-card",
      },
    ]

    if (mode === "SAR") {
      adminNavItems.push({
        key: "contract",
        label: "Contracts",
        path: "/contracts",
        icon: "bx bx-id-card",
      })
    }

    if (userRole?.has_full_permssion || userType === "superadmin") {
      return adminNavItems
    }
    const keys = Object.keys(userRole?.permissions || {})

    return adminNavItems.filter(item => {
      return keys.includes(item.key)
    })
  }

  useEffect(() => {
    if (userType === "staff" && userRole?.permissions) {
      const { permissions } = userRole
      const keys = Object.keys(permissions)
      const currentPath = window.location.pathname

      if (keys.length > 0) {
        const navItems = getAdminNavItems(mode)

        // Check if currentPath matches a sidebar item or a subroute
        const foundNav = navItems.find(
          navI =>
            currentPath === navI.path || currentPath.startsWith(`${navI.path}/`)
        )

        if (
          !foundNav &&
          navItems.length > 0 &&
          currentPath !== navItems[0].path
        ) {
          navigate(navItems[0].path, { replace: true })
        }
      }
    }

    setTimeout(() => {
      setSidebarUpdated(prev => !prev) // Toggle state to re-trigger child effect
    }, 100)
  }, [userType, userRole, mode])

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-light mt-1">
            {/* <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span> */}
            <span className="logo-lg d-flex align-items-center justify-content-center sidebar_logo">
              <img
                // className="logo_large"
                className="logo_large1 sar_logo"
                src={SARLogo}
                alt=""
                width={110}
                height={61}
              />
              <img
                // className="logo_large"
                className="logo_large1"
                src={alyamama_logo}
                alt=""
                width={120}
                height={66}
              />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {/* {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />} */}
          <SidebarContent
            sidebarUpdated={sidebarUpdated}
            userRole={userRole}
            navItems={
              userType === "candidate"
                ? getCandidatesNavItems()
                : getAdminNavItems(mode)
            }
          />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
